import { render, staticRenderFns } from "./EditEmailConfig.vue?vue&type=template&id=0470c002&scoped=true&"
import script from "./EditEmailConfig.vue?vue&type=script&lang=ts&"
export * from "./EditEmailConfig.vue?vue&type=script&lang=ts&"
import style0 from "./EditEmailConfig.vue?vue&type=style&index=0&id=0470c002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0470c002",
  null
  
)

export default component.exports